import { DEFAULT_ARTICLES_LIMIT } from '@shared/api-utils';
import { twMerge } from '@shared/themes';
import { ArticlePreviewCard } from '../ArticlePreviewCard';
import type { MagazineArticle } from '../helpers/magazineCategory';
import { mapArticleToPreviewCard } from '../helpers/mapArticleToPreviewCard';

type MagazineArticleGridProps = {
  articles: readonly MagazineArticle[];
  baseImgUrl: string;
  currentPage: number;
  priorityFirstCard?: boolean;
  className?: string;
  'data-testid'?: string;
};

function MagazineArticleGrid({
  articles,
  baseImgUrl,
  currentPage,
  priorityFirstCard = false,
  className,
  'data-testid': dataTestId = 'magazine-article-grid',
}: MagazineArticleGridProps) {
  if (articles.length === 0) {
    return null;
  }

  return (
    <ul
      className={twMerge('grid list-none grid-cols-1 gap-4 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4', className)}
      data-testid={dataTestId}
      data-track-container="Articles"
    >
      {articles.map((article, index) => (
        <li key={article.id} className="min-w-0">
          <ArticlePreviewCard
            {...mapArticleToPreviewCard(article, baseImgUrl, { priority: priorityFirstCard && index === 0 })}
            position={(currentPage - 1) * DEFAULT_ARTICLES_LIMIT + index + 1}
            data-testid={`${dataTestId}-card-${index}`}
          />
        </li>
      ))}
    </ul>
  );
}

export { MagazineArticleGrid, type MagazineArticleGridProps };
